import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "./CustomSingleSelect";
import { CompanyService } from "../services/CompanyService";
import { PersonnelService } from "../services/PersonnelService";

interface Props {
    labelText?: string
    isLabelRequired?: boolean
    selectedValue: CustomSingleSelectModel | undefined
    onChange: (_firma: CustomSingleSelectModel | undefined) => void
}

/**
 * Personelin çalıştığı firma seçimi. Listede yalnız AKTİF ve TEDARİKÇİ işaretli
 * firmalar görünür. Firma listeden seçilir; listede yoksa
 * "+" ile adı yazılır ve TEDARİKÇİ olarak oluşturulup seçilir. Aynı adlı firma
 * zaten varsa yenisi açılmaz, mevcut olan seçilir (sunucu büyük-küçük harf
 * gözetmeden karşılaştırır).
 *
 * Personel tanımlama ekranı ve sipariş ekranındaki hızlı personel tanımı aynı
 * davranışı kullansın diye tek yerde durur.
 */
const TedarikciFirmaSecimi = ({ labelText = "Firma", isLabelRequired, selectedValue, onChange }: Props) => {
    const yeniFirma = async (_ad: string) => {
        try {
            const ad = (_ad ?? '').trim();

            if (ad == '')
                return;

            const response = await PersonnelService.getOrCreateSupplierCompany(ad);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            toast.success(response.message);
            onChange({ label: response.data.name, value: response.data.companyId });
        } catch (error: any) {
            toast.error(error);
        }
    }

    return (
        <CustomSingleSelect
            labelText={labelText}
            isLabelRequired={isLabelRequired}
            selectedValue={selectedValue}
            onChange={onChange}
            onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true, selectedIsCustomActives: [{ label: 'Aktif', value: '1' }] })}
            labelName='name'
            valueName='companyId'
            insertable={{
                tooltipText: 'Listede yoksa yeni firma ekle (tedarikçi olarak kaydedilir)',
                onSubmit: { onSubmit: yeniFirma },
            }}
        />
    )
}

export default TedarikciFirmaSecimi;
